<ng-content select="header" />

@if (isLoading || hasError) {
	<ic-container
		class="ic-ui-section"
		[error]="hasError"
		[errorText]="errorText"
		[loading]="isLoading"
		[loadingText]="loadingText"
	/>
} @else {
	<div class="ic-ui-section">
		<ng-content select="aside" />
		<ng-content select="section" />
		<ng-content select="footer" />
	</div>
}

<ng-content select="footer" />
